import React, { useEffect, useState } from 'react';
import SlideShow from '../SlideShow/SlideShow';
import { GetCart, Increment, Decrement, Remove } from '../ShoppingCart/CartHandler.js'
import { Suspense } from 'react';
import { useNavigate } from "react-router-dom";
import './HomePage.css';
import { Button, Grid } from '@mui/material';
import { blue, lightBlue } from '@mui/material/colors';

import axios from "axios";
import FeaturedCards from '../FeaturedCards/FeaturedCards.js';
import PopularCards from '../PopularCards/PopularCards.js';
import SliderPage from '../PopularCards/SliderPage.js';
import NewCards from '../NewCards/NewCards.js';
import UserProducts from '../User Products/UserProducts.js';
const apiUrl = process.env.REACT_APP_BASEURL;
<link href="https://fonts.googleapis.com/css2?family=Merriweather:wght@300;400;700&display=swap" rel="stylesheet" />


const callouts = [
    {
        name: 'Desk and Office',
        description: 'Work from home accessories',
        imageSrc: 'https://tailwindui.com/img/ecommerce-images/home-page-02-edition-01.jpg',
        imageAlt: 'Desk with leather desk pad, walnut desk organizer, wireless keyboard and mouse, and porcelain mug.',
        href: '#',
    },
    {
        name: 'Self-Improvement',
        description: 'Journals and note-taking',
        imageSrc: 'https://tailwindui.com/img/ecommerce-images/home-page-02-edition-02.jpg',
        imageAlt: 'Wood table with porcelain mug, leather journal, brass pen, leather key ring, and a houseplant.',
        href: '#',
    },
    {
        name: 'Travel',
        description: 'Daily commute essentials',
        imageSrc: 'https://tailwindui.com/img/ecommerce-images/home-page-02-edition-03.jpg',
        imageAlt: 'Collection of four insulated travel bottles on wooden shelf.',
        href: '#',
    },
    {
        name: 'Travel',
        description: 'Daily commute essentials',
        imageSrc: 'https://tailwindui.com/img/ecommerce-images/home-page-02-edition-03.jpg',
        imageAlt: 'Collection of four insulated travel bottles on wooden shelf.',
        href: '#',
    },
]



function HomePage(props) {

    const [slides, setSlides] = useState([])
    const [cart, setCart] = useState(GetCart());
    const navigate = useNavigate();
    const [showCategories, setShowCategories] = useState(false);
    const [categoryOption, setCategoryOption] = useState(true);
    const [categoryOpen, setCategoryOpen] = useState(false);
    const [homeVal, setHomeVal] = useState([]);
    const [featuredVal, setFeaturedVal] = useState();
    const [popularVal, setPopularVal] = useState();
    const [newCardsVal, setNewCardsVal] = useState();
    const [userProVal, setUserProVal] = useState();
    

    
    useState(() => {

        const getHomePageSetup = () => {

            axios.get(apiUrl + `/GetHomePageSetup`, {
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + props.token.token,
                },
              })
              .then((response) => {
                setHomeVal(response.data); // Make sure response.data is an array
              })
              .catch((error) => {
                console.log(error);
              });
          };
          getHomePageSetup();
    }, [])

    useEffect(() => {
        const handleFeaturedVal = () => {
            if(homeVal?.[1]?.active === false) {
                setFeaturedVal(false);
            }else if(homeVal?.[1]?.active === true){
                setFeaturedVal(true)
            }
        }
        handleFeaturedVal();
    },[homeVal]);

    console.log(`Home Val: ${featuredVal}`);

    useEffect(() => {
        const handlePopular = () => {
            if(homeVal?.[2]?.active === false) {
                setPopularVal(false);
            }else if(homeVal?.[2]?.active === true){
                setPopularVal(true)
            }
        }
        handlePopular();
    },[homeVal]);

    useEffect(() => {
        const handleNewCards = () => {
            if(homeVal?.[3]?.active === false) {
                setNewCardsVal(false);
            }else if(homeVal?.[3]?.active === true){
                setNewCardsVal(true)
            }
        }
        handleNewCards();
    },[homeVal]);


    useEffect(() => {
        const handleUserData = () => {
            if(homeVal?.[0]?.active === false) {
                setUserProVal(false);
            }else if(homeVal?.[0]?.active === true){
                setUserProVal(true)
            }
        }
        handleUserData();
    },[homeVal]);




    const generateButtons = () => {
        if (props.categories.length !== 0) {
            return props.categories.map((catInst) => {
                return (
                    <div key={catInst.name} className="group relative" onClick={() => GetCategoryResults(catInst)}>
                        <div className="relative h-80 w-full overflow-hidden rounded-lg bg-white sm:aspect-h-1 sm:aspect-w-2 lg:aspect-h-1 lg:aspect-w-1 group-hover:opacity-75 sm:h-64">
                            <img
                                alt={'Collection of four insulated travel bottles on wooden shelf.'}
                                src={'https://th.bing.com/th/id/OIP.GA0jpMWIxi9qIZPOdzFm5AAAAA?rs=1&pid=ImgDetMain'}
                                className="h-full w-full object-cover object-center"
                            />
                        </div>
                        <h3 className="mt-2 mb-4 text-base font-semibold text-gray-600">
                            <div >
                                <span className="absolute inset-0" />
                                {catInst.name}
                            </div>
                        </h3>
                    </div>
                );
            });
        }
        return null;
    };

    const GetCategoryResults = (catInst) => {
        props.setCategory(catInst);
        navigate("/CategorySearchResults");
        window.scrollTo(0, 0);  // Scroll to the top
    };

    const handleHomeCategories = () => {
        if (!showCategories) {
            setShowCategories(true);
            setCategoryOpen(true)
        } else if (showCategories) {
            setCategoryOpen(false)
            setShowCategories(false);
        }
    }
    return (


        <div className='flex-col  center'>
            <SlideShow className='flex-row full-width center' fallback={<div>Loading....</div>} slides={slides} setSlides={setSlides}>

            </SlideShow>
            
            <div className="bg-white sm:display-none " id='cat-card'>
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    <div className="mt-3 bg-white-700" >
                        {categoryOption ? <div>
                            <Grid className='text-center ' sx={{ fontFamily: "Merriweather", fontSize: 40, color: "#3498db" }}>Looking for categories?</Grid>
                            <div className=' w-[77rem] text-center'>
                                <Button variant="outlined" onClick={() => handleHomeCategories()} sx={{ fontFamily: "Merriweather", marginTop: 1 }}>{categoryOpen ? "close categories" : "show categories"}</Button>
                            </div>
                        </div> : null}

                        {showCategories ? <h2 className="text-2xl font-bold text-gray-900" >CATEGORIES</h2> : null}
                        <div className="mt-2 space-y-12 lg:grid lg:grid-cols-4 lg:gap-x-6 lg:space-y-0">
                            {showCategories ? generateButtons() : null}
                        </div>
                    </div>
                </div>
            </div>
            <div id="">
            <div className={featuredVal ? "featured" : "feat_hidden"}>

                <Suspense className='flex-row  center' fallback={<div>Loading...</div>}>
                    <FeaturedCards setCartFunc={setCart}
                        token={props.token}
                        category={props.category} setCategory={props.setCategory}
                        categories={props.categories} setCategories={props.setCategories}
                        cartCount={props.cartCount} setCartCount={props.setCartCount}
                        homeVal = {homeVal} 
                        featuredVal = {featuredVal}
                        isSwiper = {props.isSwiper}
                        setIsSwiper = {props.setIsSwiper}
                        />
                </Suspense>
            </div>
                <div className={popularVal ? "mostPopular" : "pop_hidden"}>
                <Suspense className='flex-row full-width center' fallback={<div>Loading...</div>}>
                    <PopularCards setCartFunc={setCart}
                        token={props.token}
                        category={props.category} setCategory={props.setCategory}
                        categories={props.categories} setCategories={props.setCategories}
                        cartCount={props.cartCount} setCartCount={props.setCartCount} 
                        homeVal = {homeVal}
                        popularVal = {popularVal}
                        isSwiper = {props.isSwiper}
                        setIsSwiper = {props.setIsSwiper}
                        />
                </Suspense>
                </div>
                <div className={ newCardsVal? "newProducts" : "newPro_hidden"}>

                
                <Suspense className='flex-row full-width center' fallback={<div>Loading...</div>}>
                    <NewCards setCartFunc={setCart}
                        token={props.token}
                        category={props.category} setCategory={props.setCategory}
                        categories={props.categories} setCategories={props.setCategories}
                        cartCount={props.cartCount} setCartCount={props.setCartCount} 
                        homeVal = {homeVal}
                        newCardsVal = {newCardsVal}
                        isSwiper = {props.isSwiper}
                        setIsSwiper = {props.setIsSwiper}
                        />
                </Suspense>
                </div>
              
                <Suspense className='flex-row full-width center' fallback={<div>Loading...</div>}>
                    <UserProducts setCartFunc={setCart}
                        token={props.token}
                        category={props.category} setCategory={props.setCategory}
                        categories={props.categories} setCategories={props.setCategories}
                        cartCount={props.cartCount} setCartCount={props.setCartCount} 
                        homeVal = {homeVal}
                        userProVal = {userProVal}
                        isSwiper = {props.isSwiper}
                        setIsSwiper = {props.setIsSwiper}
                        
                        />
                </Suspense>
            </div>
        </div>
    );
};

export default HomePage;



